import type { CustomUser } from 'api';

export const ShowFeedbackWidget = (user: CustomUser): boolean => {
  if (!window.FeedbackWidget?.widget) {
    return false;
  }
  
  window.FeedbackWidget.widget.open({
    name: `${user.first_name} ${user.last_name}`,
    email: user.email as string,
    customData: {
      userId: user.id as number,
      date: new Date().toISOString(),
      process: process.env
    }
  });

  return true;
};